window.middysHawkSearchTemplates = window.middysHawkSearchTemplates || {};
window.middysHawkSearchTemplates.autocomplete = `
    <style>
        .autocomplete label {
            display: block;
            font-family: futura-pt;
            font-weight: 700;
            font-size: 14px;
            line-height: 18px;
            color: rgb(230, 0, 126);
            text-transform: uppercase;
            margin-bottom: 10px;
        }

        .autocomplete a {
            font-weight: 400;
            font-size: 14px;
            line-height: 18px;
            text-decoration: none;
        }

        .autocomplete a:hover {
            color: #E6007E;
        }

        .autocomplete__product {
            display: flex;
            align-items: center;
            flex-wrap: nowrap;
            gap: 1rem;
            margin: 0;
            padding: 0 !important;
        }

        .autocomplete__product__image {
            padding-left: 0px;
            padding-bottom: 0px;
            padding-right: 0px;
            height: 50px;
            object-fit: contain;
        }

        .autocomplete__product__image img {
            width: 50px;
            height: 50px;
            object-fit: contain;
        }
    </style>
    <div class="autocomplete">
        <div class="row">
            {{#if (or categories.results.length content.results.length queries.results.length
            productSuggestedQueries.results.length contentSuggestedQueries.results.length)}}
            <div>
                {{#if productSuggestedQueries.results.length}}
                {{#unless (eq productSuggestedQueries.title 'Top Products Did You Mean?')}}
                <label class="autocomplete__title autocomplete__title--queries">{{productSuggestedQueries.title}}</label>
                <ul class="autocomplete__list">
                    {{#each productSuggestedQueries.results}}
                    <li>
                        <a hawksearch-query="{{query}}" href="{{url}}">{{query}}</a>
                    </li>
                    {{/each}}
                </ul>
                {{/unless}}
                {{/if}}
                {{#if categories.results.length}}
                <label class="autocomplete__title autocomplete__title--categories">{{categories.title}}</label>
                <ul class="autocomplete__list">
                    {{#each categories.results}}
                    <li>
                        <a hawksearch-category-field="{{field}}" hawksearch-category-value="{{value}}"
                            href="{{url}}">{{html title}}</a>
                    </li>
                    {{/each}}
                </ul>
                {{/if}}
                {{#if content.results.length}}
                <label class="autocomplete__title autocomplete__title--content">{{content.title}}</label>
                <ul class="autocomplete__list">
                    {{#each content.results}}
                    <li>
                        <a hawksearch-content="{{id}}" href="{{url}}">{{html title}}</a>
                    </li>
                    {{/each}}
                </ul>
                {{/if}}
                {{#if queries.results.length}}
                <label class="autocomplete__title autocomplete__title--queries">{{queries.title}}</label>
                <ul class="autocomplete__list">
                    {{#each queries.results}}
                    <li>
                        <a hawksearch-query="{{query}}" href="{{url}}">{{query}}</a>
                    </li>
                    {{/each}}
                </ul>
                {{/if}}
            </div>
            {{/if}}
            {{#if products.results.length}}
            <div>
                <label>PRODUCT MATCHES</label>
                <div class="autocomplete__products">
                    {{#each products.results}}
                    <div>
                        <div class="autocomplete__product">
                            <a hawksearch-product="{{id}}" href="{{url}}" class="autocomplete__product__image">
                                <img hawksearch-image src="{{productImageUrl imageUrl 50 50}}" alt="" />
                            </a>
                            <span class="autocomplete__product__title">
                                <a hawksearch-product="{{id}}"
                                    href="{{productUrl attributes.product_name attributes.product_pronto_code}}">{{html
                                    title}}</a>
                            </span>
                            <hawksearch-variant-selector></hawksearch-variant-selector>
                        </div>
                    </div>
                    {{/each}}
                </div>
            </div>
            {{/if}}
        </div>
        <div class="autocomplete__view-all">
            <a hawksearch-view-all>VIEW ALL RESULTS</a>
        </div>
    </div>
`;
